import { StoreList } from './StoreList';
import StoreIcon from '@mui/icons-material/Store';

export default {
    icon: StoreIcon,
    list: StoreList,
};
